import { Box } from '#/components/Box/Box';
import { FilestackImage } from '#/components/FilestackImage/FilestackImage';
import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import type { CmsApiLogosBlockData } from '#/modules/cms/api/types/blocks/CmsApiLogosBlock';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';

import {
  LogoImageContainer,
  LogoImageGroupContainer,
  LogosButtonContainer,
} from './CmsLogosBlock.styled';
import { Button } from '#/components/Button/Button';

type Props = {
  data: CmsApiLogosBlockData;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsLogosBlock({ data, blockIndex, pageUpdated }: Props) {
  const { headline, sections, buttonText, buttonUrl } = data;

  return (
    <Box qaId={`logos-${blockIndex}`}>
      {headline && (
        <RichTextHeadline textAlignCenter>{headline}</RichTextHeadline>
      )}
      {sections.map((section) => (
        <LogoImageGroupContainer
          key={[
            section.imageOne.altText,
            section.imageTwo.altText,
            section.imageThree.altText,
          ].join('-')}
        >
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageOne.altText}
              data={section.imageOne}
              qaId={`image-${section.imageOne.altText}`}
              height={94}
            />
          </LogoImageContainer>
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageTwo.altText}
              data={section.imageTwo}
              qaId={`image-${section.imageTwo.altText}`}
              height={94}
            />
          </LogoImageContainer>
          <LogoImageContainer>
            <FilestackImage
              alt={section.imageThree.altText}
              data={section.imageThree}
              qaId={`image-${section.imageThree.altText}`}
              height={94}
            />
          </LogoImageContainer>
        </LogoImageGroupContainer>
      ))}

      {buttonText && buttonUrl && (
        <LogosButtonContainer>
          <Button
            variant="primary"
            type="link"
            href={buttonUrl}
            onClick={(event) =>
              trackAnchorClicked(event, 'CMS Block', {
                block_position: blockIndex,
                block_type: 'Logos',
                cta_type: 'Button',
                page_updated: pageUpdated,
              })
            }
          >
            {buttonText}
          </Button>
        </LogosButtonContainer>
      )}
    </Box>
  );
}
